export default __webpack_public_path__ + "static/media/more-vertical.6f825e7a.svg";